import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
    isJobCostLoading: false,
    isBatchesLoading: false,
    isPhaseGroupsLoading: false,
    isPayrollsLoading: false,
    isFieldTicketsLoading: false,
    error: null,
    job_costs: null,
    batches: null,
    documents: null,
    phase_groups: null,
    payrolls: null,
    field_tickets: null,
};

const slice = createSlice({
    name: 'job_cost',
    initialState,
    reducers: {
        // START LOADING
        startJobCostLoading(state) {
            state.isJobCostLoading = true;
        },
        startBatchesLoading(state) {
            state.isBatchesLoading = true;
        },
        startPhaseGroupsLoading(state) {
            state.isPhaseGroupsLoading = true;
        },
        startPayrollsLoading(state) {
            state.isPayrollsLoading = true;
        },
        startFieldTicketsLoading(state) {
            state.isFieldTicketsLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isJobCostLoading = false;
            state.isBatchesLoading = false;
            state.isDocumentsLoading = false;
            state.isPhaseGroupsLoading = false;
            state.isPayrollsLoading = false;
            state.isFieldTicketsLoading = false;
            state.error = action.payload;
        },
        // GET JOB COSTS
        setJobCost(state, action) {
            state.isJobCostLoading = false;
            state.job_costs = action.payload;
        },
        // GET BATCHES
        setBatches(state, action) {
            state.isBatchesLoading = false;
            state.batches = action.payload;
        },
        // GET PHASE GROUPS
        setPhaseGroups(state, action) {
            state.isPhaseGroupsLoading = false;
            state.phase_groups = action.payload;
        },
        // GET PAYROLLS
        setPayrolls(state, action) {
            state.isPayrollsLoading = false;
            state.payrolls = action.payload;
        },
        // GET FIELD TICKETS
        setFieldTickets(state, action) {
            state.isFieldTicketsLoading = false;
            state.field_tickets = action.payload;
        },
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    startJobCostLoading,
    startBatchesLoading,
    startPhaseGroupsLoading,
    startPayrollsLoading,
    startFieldTicketsLoading,
    hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getJobCost() {
    return async () => {
        dispatch(slice.actions.startJobCostLoading());
        try {
            const response = await axios.get(`/dropdown/job/job_costs`);
            dispatch(slice.actions.setJobCost(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getBatche() {
    return async () => {
        dispatch(slice.actions.startBatchesLoading());
        try {
            const response = await axios.get(`/admin/job_cost/batches`);
            dispatch(slice.actions.setBatches(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getPhaseGroup() {
    return async () => {
        dispatch(slice.actions.startPhaseGroupsLoading());
        try {
            const response = await axios.get(`/admin/job_cost/phase_groups`);
            dispatch(slice.actions.setPhaseGroups(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getPayroll() {
    return async () => {
        dispatch(slice.actions.startPayrollsLoading());
        try {
            const response = await axios.get(`/admin/job_cost/payrolls`);
            dispatch(slice.actions.setPayrolls(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getFieldTicket() {
    return async () => {
        dispatch(slice.actions.startFieldTicketsLoading());
        try {
            const response = await axios.get(`/admin/job_cost/field_tickets`);
            dispatch(slice.actions.setFieldTickets(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
